/**
 * Created by tatekim on 2016. 3. 7..
 */
(function(document, angular, undefined) {
    'use strict';

    var m = angular.module('vvTaskUtil', []);

    m.service('vvTaskService', function($q, $timeout) {
        var vvTaskService = this;

        vvTaskService.makeObsoleteTask = function(f, timeoutDelay) {
            var rev = 0;
            var canceler = null;
            var promise = $q.when(null);

            var wrapped = function() {
                var args = arguments;
                rev = rev + 1;
                if (canceler) {
                    (function (resolve, delay) {
                        $timeout(function() { resolve(); }, delay || 1000);
                    })(canceler.resolve.bind(canceler), timeoutDelay);
                }
                canceler = $q.defer();
                promise = (function (_rev, obsoletePromise) {
                    return promise.catch(function(err) {
                        // console.log('catched', err);
                        // ignore
                    }).then(function () {
                        if (rev > _rev) {
                            console.log('skip rev', _rev, rev);
                            return $q.reject('skipped');
                        }


                        var ctx = {
                            isObsolete: function() {
                                return rev > _rev;
                            },
                            obsoletePromise: obsoletePromise,
                            obsoleted: obsoletePromise,
                            overlapped: obsoletePromise,
                        };
                        ctx.isOverlapped  = ctx.isObsolete;

                        // console.log(f, args);
                        return f.apply(ctx, args);
                    });
                })(rev, canceler.promise);
                return promise;
            };

            return wrapped;
        };

        vvTaskService.makeOverlapTask = function() {
            return vvTaskService.makeObsoleteTask.apply(this, arguments);
        };

        vvTaskService.runParallel = function(name, jobList, taskFunc, maxTasks) {
            var promise = $q.when(null);
            var canceled = false;
            var jobIdx = 0;
            if (!jobList) {
                return $q.when();
            }
            var _runTask = function (idx, taskFunc) {
                if (!canceled && jobIdx < (jobList && jobList.length) || 0) {
                    var job = jobList[jobIdx++];
                    // 여기서 넘겨준 promise를 이용하면, 받아온 data를 순차적으로 처리할수 있다.
                    promise = $q.when(taskFunc(job, promise));
                    return promise.then(function () {
                        return _runTask(idx, taskFunc);
                    }, function(err) {
                        canceled = true;
                        console.log('task error', name, idx, err);
                        return $q.reject(err);
                    });
                }
                if (jobList.length > 0)
                    console.log('task ends', name, idx, 'total jobs', jobList.length);
                return $q.when();
            };

            var promises = [];
            maxTasks = Math.min(jobList.length, maxTasks);
            for (var i = 0; i < maxTasks; i++) {
                promises.push(_runTask(i, taskFunc));
            }

            return $q.all(promises);
        };

        vvTaskService.makeMutualTask = function(f, opts) {
            opts = angular.extend({
                concurrent: 1,
                onNoMoreTask: function() { alert('Another task is already running. Wait and try again.'); },
            }, opts);
            var running = 0;
            return function() {
                var args = arguments;

                if (running >= opts.concurrent) {
                    if (opts.onNoMoreTask) {
                        opts.onNoMoreTask();
                    }
                    return $q.reject('no more task available');
                }
                running++;
                return $q.when().then(function() {
                    return f.apply(null, args);
                }).finally(function() {
                    running--;
                });
            };
        };

        vvTaskService.testMutualTask = function() {
            var taskLog = vvTaskService.makeMutualTask(function(str) {
                return $timeout(function() {
                    if (str > 0 && str % 3 == 0) {
                        console.log('error');
                        throw 'Error'
                    }
                    console.log(str);
                }, (Math.random() * 500) + 500);
            }, {concurrent: 2});
            for (var i = 0; i < 10; i++) {
                taskLog(i).catch(function(e) {
                    console.log('error', e);
                }).then(function() {
                    taskLog(i+10);
                });
            }
        };

        vvTaskService.makeQueuedTask = function(f, opts) {
            opts = angular.extend({
                'concurrent': 1,
            }, opts);
            var running = 0;
            var deferredList = [];

            return function() {
                var args = arguments;

                var promise;
                // console.log('[0]running', running);
                if (running >= opts.concurrent) {
                    var deferred = $q.defer();
                    deferredList.push(deferred);
                    promise = deferred.promise;
                } else {
                    promise = $q.when();
                    running++;
                }

                return promise.then(function() {
                    console.log('[s]running', running);
                    return f.apply(null, args);
                }).finally(function () {
                    // console.log('[e]running', running);
                    if (deferredList.length > 0) {
                        deferredList.shift().resolve();
                    } else {
                        running--;
                    }
                });
            };
        };

        vvTaskService.testQueuedTask = function() {
            var taskLog = vvTaskService.makeQueuedTask(function(str) {
                return $timeout(function() {
                    if (str > 0 && str % 3 == 0) {
                        console.log('error');
                        throw 'Error'
                    }
                    console.log(str);
                }, (Math.random() * 500) + 500);
            }, {concurrent: 1});
            for (var i = 0; i < 10; i++) {
                taskLog(i).catch(function(e) {
                    console.log('error', e);
                });
            }
        };

        vvTaskService.catch = function(f, f_catch, f_final) {
            return function() {
                var args = arguments;
                var p = $q.when().then(function() {
                    return f.apply(null, args);
                }).catch(f_catch);
                if (f_final) {
                    p = p.finally(f_final);
                }
                return p;
            };
        };
    });

})(document, angular);
